import React, { Component } from 'react';
import axios from 'axios';
import Modal from './global/modal';
import { db } from '../firebase';

export default class SendEmails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountId: this.props.accountId,
      current360Id: this.props.current360Id,
      currentGroupId: this.props.currentGroupId,
      currentGroupUsers: this.props.currentGroupUsers,
      currentGroupUsersReviewers: this.props.currentGroupUsersReviewers,
      current360: this.props.current360,
      activeTask: this.props.activeTask,
      userEmail: this.props.loggedIn,
      mailTo: [],
      isModalOpen: false,
      loading: false,
      theKey: this.props.theKey,
    };
  }
  componentDidMount() {
    db.doGetCurrent360ReviewerEmailText(this.state.accountId, this.props.current360Id).onSnapshot((snapshot) => {
      if (snapshot.data() === undefined) {
        const current360EmailText = [
          {
            body_text: this.props.current360.type !== 'Team Assessment' ? '[NAME] has requested you to complete their review.' : 'Please complete your team review for [NAME]',
            button_text: 'Click here to complete their review',
            title: 'Hi [NAME]!',
          },
        ];
        this.setState({
          current360EmailText: current360EmailText,
          loaded: true,
        });
      } else {
        this.setState({
          current360EmailText: snapshot.data(),
          loaded: true,
        });
      }
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        activeTask: this.props.activeTask,
        currentGroupUsers: this.props.currentGroupUsers,
        currentGroupUsersReviewers: this.props.currentGroupUsersReviewers,
      });
    }
  }

  updateEmail(groupID, reminderNumber, mailsSent) {
    this.props.succesfullyCompletedEmailSendActions(groupID, reminderNumber, mailsSent);
  }

  showCreditsModal() {
    this.props.promptCreditsModal();
  }

  closeModal(e) {
    this.setState({ isModalOpen: false });
  }

  openModal(e) {
    this.setState({ isModalOpen: true });
  }

  sendRequest(reqBody, numberOfUsers, pathString) {
    const { currentGroupId, activeTask } = this.state;
    axios
      .post(
        pathString,
        {
          reqBody,
          cookies: window.localStorage.getItem('Auth'),
        },
        { timeout: 45000, timeoutErrorMessage: 'Timed Out' }
      )
      .then((res) => {
        const { data } = res;
        this.updateEmail(currentGroupId, activeTask, numberOfUsers);

        if (pathString === '/goalTrackerEmail' || data.status === 'sending') {
          this.setState({
            emailStatuses: data,
            loading: 'The emails are being sent, you can now close this window',
          });
        } else {
          this.setState({
            loading: data.status,
          });
        }
      })
      .catch((err) => {
        const generationErrorString = 'There has been an error generating some or all of the emails';
        if (err.message === 'Request failed with status code 400') {
          this.setState({
            loading: generationErrorString,
          });
        } else if (err.message === 'Request failed with status code 500') {
          this.setState({
            loading: generationErrorString,
          });
        }
        if (err === 'Error: Timed Out') {
          this.updateEmail(currentGroupId, activeTask, numberOfUsers);
          this.setState({
            loading: 'The emails are being sent, you can now close this window.',
          });
        } else {
          this.setState({
            loading: generationErrorString,
          });
        }
      });
  }

  sendEmails(e) {
    e.preventDefault();

    this.setState({ isModalOpen: true, loading: 'Processing Request' });

    const { currentGroupUsers, current360, currentGroupUsersReviewers, activeTask, sendReminder } = this.props;

    const numberOfUsers = Object.keys(currentGroupUsers).length;

    const checkType = (type) => {
      if (type === '360') {
        return numberOfUsers;
      } else if (type === 'Team Assessment') {
        if (currentGroupUsersReviewers) {
          return Object.keys(currentGroupUsersReviewers).length;
        }
      }
    };

    let numOfUsers = checkType(current360.type);
    let reminderNumber;
    // if (activeTask === '' || activeTask < 2) {
    // Use above for build, the below conditional is just to bypass credits check during testing
    if (activeTask === '') {
      reminderNumber = 1;
    }

    if (reminderNumber === 1 && numOfUsers > this.props.credits) {
      this.setState({
        isModalOpen: false,
      });
      this.showCreditsModal();
    } else if (current360.type !== 'Goal Tracker') {

      let uniqueReviewerData = {};

      const checkArr = {};

      for (const reviewerID in currentGroupUsersReviewers) {
        const { email, currentReviewerID } = currentGroupUsersReviewers[reviewerID];

        // separates reviewers by unique email, then assigns relevant IDs to them
        if (!uniqueReviewerData[email]) {
          uniqueReviewerData[email] = {
            ids:  [reviewerID],
            nullCheck: false
          };
          checkArr[reviewerID] = email;
        } else {
          uniqueReviewerData[email].ids.push(reviewerID);
        }

        // checks for any null values to combined reviewer IDs
        if (currentReviewerID === null) {
          uniqueReviewerData[email].nullCheck = true;
        }
      }

      // loop again, removing any items with less than 2 reviewers associated
      for (const reviewerID in currentGroupUsersReviewers) {
        const { email } = currentGroupUsersReviewers[reviewerID];
        if (uniqueReviewerData[email].ids.length < 2) {
          delete uniqueReviewerData[email];
          delete checkArr[reviewerID];
        }
      }

      const reqBody = this.state;
      reqBody.combineSend = checkArr;
      reqBody.combineSendIds = uniqueReviewerData;

      if (sendReminder) {
        // For post-schedule further reminders
        reqBody.sendReminder = true;
        // this.sendRequest(reqBody, numberOfUsers, '/send360Emails');
        this.sendRequest(reqBody, numberOfUsers, '/send360EmailsStaging');
      } else {
        // For legacy instruction and reminder format
        // this.sendRequest(reqBody, numberOfUsers, '/send360Emails');
         this.sendRequest(reqBody, numberOfUsers, '/send360EmailsStaging');
      }
    } else {
      const reqBody = this.state;
      this.sendRequest(reqBody, numberOfUsers, '/goalTrackerEmail');
    }
  }

  render() {
    const { sendReminder, showModalButtonLabel, modalContentLabel, modalHeader } = this.props;
    return (
      <div className='ml4'>

        {sendReminder ? (
          // This will appear on a group once all 4 scheduled reminders have been sent
          <button disabled={false} className='btn' onClick={(e) => this.sendEmails(e)}>
            Send Reminder
          </button>
        ) : (
          // This is present for legacy groups
          Object.keys(this.state.currentGroupUsers).length === 0 ? (
            <button disabled={true} className='btn' onClick={(e) => this.sendEmails(e)}>
              {showModalButtonLabel}
            </button>
          ) : this.state.activeTask.toString() !== this.state.theKey ? (
            <button disabled={true} className='btn' onClick={(e) => this.sendEmails(e)}>
              {showModalButtonLabel}
            </button>
          ) : (
            <button disabled={false} className='btn' onClick={(e) => this.sendEmails(e)}>
              {showModalButtonLabel}
            </button>
          )
        )}

        <Modal
          isOpen={this.state.isModalOpen}
          contentLabel={modalContentLabel}
          onClose={(e) => {
            this.closeModal(e);
          }}
          hideCloseButton={this.state.loading === 'Processing Request'}
          content={
            <div className='center w-100 tc'>
              <h3>{sendReminder ? 'Send Reminder' : modalHeader}</h3>
              <div className='centerForm tc'>
                {this.state.loading === false ? (
                  <div>
                    <button onClick={(e) => this.sendEmails(e)} className='btn' type='submit'>
                      submit
                    </button>
                  </div>
                ) : (
                  <span> {this.state.loading}</span>
                )}
              </div>
            </div>
          }
        />
      </div>
    );
  }
}
